import { Clients, Sucursales } from './../../../interfaces/clients';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Responses } from 'src/app/shared/interfaces/responses';

@Injectable({
  providedIn: 'root',
})
export class ClientsService {
  private urlBase = environment.urlBase;
  private urlPostal = environment.urlCopomex;

  constructor(private http: HttpClient) {}

  // Obtiene todos los roles activos
  getClients(): Observable<Responses> {
    return this.http.post<Responses>(`${this.urlBase}clients/getClients`, null);
  }
  //Función para registrar el Rol
  createClient(client: Clients): Observable<Responses> {
    return this.http.post<Responses>(
      `${this.urlBase}clients/createClient`,
      client,
    );
  }
  // Funcion para subir archivo csf
  uploadClientCsf(id: number, file: File): Observable<Responses> {
    const fd = new FormData();
    fd.append('csf', file);
    return this.http.post<Responses>(
      `${this.urlBase}clients/uploadCsf/${id}`,
      fd,
    );
  }
  //Función para actualizar el Rol
  updateClient(client: Clients): Observable<Responses> {
    return this.http.post<Responses>(
      `${this.urlBase}clients/updateClient`,
      client,
    );
  }
  //Función para eliminar el Rol
  deleteClient(client: Clients): Observable<Responses> {
    return this.http.post<Responses>(
      `${this.urlBase}clients/deleteClient`,
      client,
    );
  }

  countClient(): Observable<Responses> {
    return this.http.post<Responses>(
      `${this.urlBase}clients/countClients`,
      null,
    );
  }

  getNextClientFolio(): Observable<Responses> {
    return this.http.get<Responses>(`${this.urlBase}clients/nextClientFolio`);
  }

  getNextClientNewFolio(): Observable<Responses> {
    return this.http.get<Responses>(
      `${this.urlBase}clients/nextClientNewFolio`,
    );
  }

  getTownship(cp: any): Observable<any> {
    const cpNorm = String(cp ?? '').padStart(5, '0');
    return this.http.get<any>(
      `https://api.copomex.com/query/info_cp/${cpNorm}?token=fd92b02e-6a46-4206-afd4-3879a6055344`,
    );
  }

  //Función para actualizar las credenciales
  updateCredential(client: any): Observable<Responses> {
    return this.http.post<Responses>(
      `${this.urlBase}clients/updateCredential`,
      client,
    );
  }

  //Funcion para crear sucursal
  createBranch(branch: any): Observable<Responses> {
    return this.http.post<Responses>(
      `${this.urlBase}branchOffices/createBranchOffice`,
      branch,
    );
  }

  //Función para actualizar la sucursal
  updateBranch(branch: Sucursales): Observable<Responses> {
    return this.http.post<Responses>(
      `${this.urlBase}branchOffices/updateBranchOffice`,
      branch,
    );
  }

  //Función para eliminar la sucursal
  deleteBranch(branch: Sucursales): Observable<Responses> {
    return this.http.delete<Responses>(
      `${this.urlBase}branchOffices/deleteBranchOffice`,
      { body: branch },
    );
  }

  //Funcion para obtener las sucursales por ID
  getBranchByClientId(id: any): Observable<any> {
    return this.http.get<any>(
      `${this.urlBase}branchOffices/getBranchOfficesByClient/${id}`,
    );
  }

  // Obtener los tipos de pago
  getPaymentTypes(): Observable<Responses> {
    return this.http.post<Responses>(
      `${this.urlBase}paymentTypes/getPaymentTypes`,
      null,
    );
  }

  getAdvisorCustomerByUser(): Observable<Responses> {
    return this.http.post<Responses>(
      `${this.urlBase}clients/getUsersByCustomerAdvisor`,
      null,
    );
  }

  //Función para actualizar las credenciales en sucursales
  updateCredentialBranch(branch: any): Observable<Responses> {
    return this.http.post<Responses>(
      `${this.urlBase}branchOffices/updateCredentialBranchOffice`,
      branch,
    );
  }

  getNextBranchOfficeFolio(): Observable<Responses> {
    return this.http.get<Responses>(
      `${this.urlBase}branchOffices/nextBranchOfficeNewFolio`,
    );
  }

  downloadClientCSF(id: number) {
    return this.http.get(`${this.urlBase}clients/download-csf/${id}`, {
      responseType: 'blob',
      observe: 'response',
    });
  }

  prospecConvertCliente(id: number) {
    return this.http.patch(
      `${this.urlBase}clients/prospecConvertCliente/${id}`,
      {
        responseType: 'blob',
        observe: 'response',
      },
    );
  }

  downloadExcel(filters: { search: string; status: string }): Observable<Blob> {
    return this.http.post(`${this.urlBase}clients/downloadExcel`, filters, {
      responseType: 'blob',
    });
  }

  getAccountStatement(
    clienteId?: number,
    tipoEntidad?: 'CLIENTE' | 'SUCURSAL',
  ): Observable<Responses> {
    // Sin entidad el backend resuelve la del usuario de la sesión.
    const params =
      clienteId && tipoEntidad
        ? { params: { ClienteId: clienteId, TipoEntidad: tipoEntidad } }
        : {};

    return this.http.get<Responses>(
      `${this.urlBase}accountStatements/accounts-statements`,
      params,
    );
  }

  enviarEstadoCuenta(id: number, to?: string): Observable<Responses> {
    return this.http.post<Responses>(
      `${this.urlBase}accountStatements/enviar`,
      { Id: id, to: to || undefined },
    );
  }

  downloadPDFAccount(id: number): Observable<Blob> {
    return this.http.get(
      `${this.urlBase}accountStatements/download-pdf/${id}`,
      {
        responseType: 'blob',
      },
    );
  }

  uploadCustomerRegistration(id: number, file: File): Observable<Responses> {
    const fd = new FormData();
    fd.append('customer_registration', file);
    return this.http.post<Responses>(
      `${this.urlBase}clients/uploadCustomerRegistration/${id}`,
      fd,
    );
  }

  downloadCustomerRegistration(id: number) {
    return this.http.get(
      `${this.urlBase}clients/download-customer-registration/${id}`,
      {
        responseType: 'blob',
        observe: 'response',
      },
    );
  }

  updateClientFolio(id: number, NewFolio: number): Observable<Responses> {
    return this.http.patch<Responses>(
      `${this.urlBase}clients/updateClientFolio/${id}`,
      {
        NewFolio,
      },
    );
  }

  updateBranchOfficeFolio(id: number, NewFolio: number): Observable<Responses> {
    return this.http.patch<Responses>(
      `${this.urlBase}branchOffices/updateBranchOfficeFolio/${id}`,
      {
        NewFolio,
      },
    );
  }
}
